// import dayjs from 'dayjs'; //https://day.js.org/
// import utc from 'dayjs/plugin/utc';
import Util from '@/helper/Utility.js';
import Locale from "@/helper/locale/Locale.js";
import { DateTime } from "luxon"; //https://moment.github.io/luxon

export default {
    /********* Datetime *********
     * @function convertDateToTimeStampUnix
     * @function getTimeZoneOffsetHour
     * @function isDatetimeValid
     * @function cleanTimeFormDatetime
     * @function getEndOfMonth
     * @function getEndOfMonthDay
     * @function getDateByValue
     * @function unixTimestampToDate
     * @function stringToDate
    ****************************/
    /**
     * @param {Date} date
     */
    convertDateToTimeStampUnix: function(date) {
        var unixTime = Math.floor((date.getTime() - date.getTimezoneOffset() * 60 * 1000) / 1000);
        return unixTime;
    },

    getTimeZoneOffsetHour: function () {
        let h = new Date().getTimezoneOffset() / 60;
        return h;
    },

    /**
     * @param {number|string} y - A.D. year only, ปี ค.ศ. เท่านั้น (Thai year need to convert before check.)
     * @param {number|string} m - (1 - 12)
     * @param {number|string} d - (1 - 31)
     */
    isDatetimeValid: function(y, m, d) {
        let dt = DateTime.fromObject({ year: y, month: m, day: d });
        return dt.isValid;
    },
    cleanTimeFormDatetime: function(datetime) {
        var date = new Date(datetime.getFullYear(), datetime.getMonth(), datetime.getDate());
        return date;
    },
    getEndOfMonth: function(year, month) {
        let dt = DateTime.fromObject({ year: year, month: month, day: 1 });
        let end = dt.endOf('month').toJSDate();
        return end;
    },
    getEndOfMonthDay: function (year, month) {
        let lastDate = this.getEndOfMonth(year, month);
        return lastDate.getDate();
    },
    /**
     * @param {string|number} year YYYY
     * @param {string|number} month MM : 1-12
     * @param {string|number} day DD : 1-31
     */
    getDateByValue: function (year, month, day) {
        let dt = DateTime.fromObject({ year: year, month: month, day: day });
        return dt.toJSDate();
    },

    unixTimestampToDate: function (timestamp) {
        if (!Util.isNumber(timestamp) || Util.isEmptyStr(timestamp)) {
            return null;
        }
        let dt = DateTime.fromSeconds(timestamp, { zone: 'utc' });
        // let offset = this.getTimeZoneOffsetHour();
        // dt = dt.plus({ hours: offset });
        dt = dt.plus({ hours: -7 });
        return dt.toJSDate();
    },

    unixTimestampToDateNotPlus: function (timestamp) {
        if (!Util.isNumber(timestamp) || Util.isEmptyStr(timestamp)) {
            return null;
        }
        let dt = DateTime.fromSeconds(timestamp);
        return dt.toJSDate();
    },

    stringToDate: function (string, format) {
        let dt = DateTime.fromFormat(string, format);
        return dt.toJSDate();
    },

    /********** Date Format ***********
     * @function timestampFullFormat
     * @function dateFullFormat
     * @function getDatetimeFullFormat
     * @function getYearByLocale
     * @function timeFormat
     **********************************/

    timestampFullFormat: function (timestamp) {
        let date = this.unixTimestampToDate(timestamp);
        return this.dateFullFormat(date);
    },
    dateFullFormat: function (datetime) {
        let dt = DateTime.fromJSDate(datetime);

        if (Locale.getLocaleCode() == 1054) {
            return dt.reconfigure({ outputCalendar: "buddhist" })
                .setLocale("th")
                .toFormat('dd MMMM yyyy');
        } else {
            return dt.toFormat('dd MMMM yyyy');
        }
    },
    getDatetimeFullFormat: function (timestamp) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);

        if (Locale.getLocaleCode() == 1054) {
            return dt.reconfigure({ outputCalendar: 'buddhist' })
                .setLocale("th")
                .toFormat('dd MMMM yyyy - HH:mm');
        } else {
            return dt.toFormat('dd MMMM yyyy - HH:mm');
        }
    },
    getDatetimeFormat: function (timestamp) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);

        if (Locale.getLocaleCode() == 1054) {
            return dt.reconfigure({ outputCalendar: 'buddhist' })
                .setLocale("th")
                .toFormat('dd MMM yyyy - HH:mm');
        } else {
            return dt.toFormat('dd MMM yyyy - HH:mm');
        }
    },
    getDateShortFormat: function (timestamp) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);

        if (Locale.getLocaleCode() == 1054) {
            return dt.reconfigure({ outputCalendar: 'buddhist' })
                .setLocale("th")
                .toFormat('dd/MM/yyyy');
        } else {
            return dt.toFormat('dd/MM/yyyy');
        }
    },
    dateTimeFullFormatShortMonth: function (timestamp) {
        let date = this.unixTimestampToDateNotPlus(timestamp);
        let dt = DateTime.fromJSDate(date);

        if (Locale.getLocaleCode() == 1054) {
            return dt.reconfigure({ outputCalendar: "buddhist" })
                .setLocale("th")
                .toFormat('dd MMM yy, HH:mm');
        } else {
            return dt.toFormat('dd MMM yy, HH:mm');
        }
    },
    dateIsoFormat: function (datetime) {
        let dt = DateTime.fromJSDate(datetime);
        return dt.toFormat('yyyy-MM-dd');
    },
    dateIsoFormatNoDate: function (datetime) {
        let dt = DateTime.fromJSDate(datetime);
        return dt.toFormat('yyyy-MM');
    },
    getYearByLocale: function(year) {
        if (Locale.getLocaleCode() == 1033) {
            return year;
        }
        return parseInt(year) + 543;
    },
    timeFormat: function (timestamp) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);
        return dt.toFormat('HH:mm:ss');
    },
    getTimeCacheHour: function () {
        let str = DateTime.now().toFormat('yyyyMMddHH');
        return str;
    },
    getDatePlus: function (timestamp, value) {
        let date = this.unixTimestampToDate(timestamp);
        let dt = DateTime.fromJSDate(date);

        dt = dt.plus({ days: value });

        return dt;

    },
    dateShortFormat: function(date){
        if (Locale.getLocaleCode() == 1054) {
            return date.reconfigure({ outputCalendar: 'buddhist' })
                .setLocale("th")
                .toFormat('dd/MM/yyyy');
        } else {
            return date.toFormat('dd/MM/yyyy');
        }
    },
    getDateDiffToday: function(value, format){
        let datediff = value;
        let dateToday = DateTime.now();
        if(format){
            datediff = value.toFormat('yyyy-MM-dd');
            dateToday = DateTime.now().toFormat('yyyy-MM-dd');
        }
        console.log('dateToday', dateToday);
        console.log('value', value);
        // console.log('now', DateTime.now())
        // console.log('dt', value.toFormat('yyyy-MM-dd'));
        // console.log('now', DateTime.now().toFormat('yyyy-MM-dd'));
        const today = DateTime.fromISO(dateToday);
        const date = DateTime.fromISO(datediff);

        const diff = today.diff(date, ['months', 'days', 'hours']).toObject();

        return diff;

    },
    getTimeDiffToday: function(){
        let today = DateTime.now();
        let endDay = DateTime.now().endOf('day');
        let diff = endDay.diff(today, 'hours').hours;

        return diff;
    },
    /**
     * @param {Date} date1 fotmat Wed Oct 19 2022 10:44:03 GMT+0700 (Indochina Time)
     * @param {Date} date2 fotmat Wed Oct 19 2022 10:44:03 GMT+0700 (Indochina Time)
     */
    calDiffInHour: function (date1, date2) {
        const time = date2 - date1;
        return (time / (1000 * 60 * 60));
    },
    /**
     * @param {Date} date1 fotmat Wed Oct 19 2022 10:44:03 GMT+0700 (Indochina Time)
     * @param {Date} date2 fotmat Wed Oct 19 2022 10:44:03 GMT+0700 (Indochina Time)
     */
    calDiffInDay: function (date1, date2) {
        const time = Math.abs(date2 - date1);
        return Math.round(time / (1000 * 60 * 60 * 24));
    }
}
